<template>
  <!-- not sure why height works on mobile, should be min-height, but min-height disables scrolling -->
  <div
    id="sidebar-container" class="d-flex flex-column px-3" tabindex="-1"
    :style="{ marginRight: marginRight, top: offsetTop, height: height, outline: 'none' }"
    aria-controls="card-search-results street-address__error-msg city__error-msg server__error-msg">

    <form role="search" aria-label="Filter Schools">

      <div class="sidebar-section d-none d-widescreen-flex justify-content-widescreen-between align-items-widescreen-center my-4 pb-4">
        <!-- <i class="fas fa-filter fa-2x"></i> -->
        <h2 class="is-size-1 font-family-montserrat">Filters</h2>
        <button
          class="button is-danger is-small focus-outline-yellow"
          @click.prevent="reset"
          aria-controls="card-search-results">
            Clear Filters
        </button>
      </div>

      <fieldset class="sidebar-section my-4 pb-4" >
        <legend class="is-size-3 text-center py-2 font-family-montserrat">School Type</legend>
        <cmps-radio name="grade-level" value="preschool">Preschool</cmps-radio>
        <cmps-radio name="grade-level" value="elementary">Elementary</cmps-radio>
        <cmps-radio name="grade-level" value="junior_high">Junior High</cmps-radio>
        <cmps-radio name="grade-level" value="high_school">Senior High</cmps-radio>
        <cmps-radio name="grade-level" value="choice_school">Choice</cmps-radio>
      </fieldset>

      <fieldset class="sidebar-section my-4 pb-4">
        <legend class="is-size-3 text-center py-2 font-family-montserrat">School Programs</legend>
        <cmps-check-group v-for="category in categories" :key="category.id" :category="category"></cmps-check-group>
      </fieldset>

      <!-- <fieldset class="sidebar-section my-4 pb-4" aria-controls="card-search-results street-address__error-msg city__error-msg server__error-msg"> -->
      <fieldset class="sidebar-section my-4 pb-4">
        <legend class="is-size-3 text-center py-2 font-family-montserrat">Mailing Address</legend>
        <p class="mb-4">Sort schools by distance from an address. All distances given are an approximation.</p>
        <div class="field">
          <div class="control">
            <label for="street" class="label" style="color: white;">Street address</label>
          </div>
          <div class="control is-expanded">
            <input type="text" class="input focus-outline-yellow" id="street" v-model="street" :aria-invalid="errors.check('street')" >
            <p class="help is-warning is-size-5" v-text="errors.get('street')" aria-live="polite" aria-atomic="true" aria-relevant="all" id="street-address__error-msg"></p>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <label for="city" class="label" style="color: white;">City</label>
          </div>
          <div class="control">
            <div class="select w-100">
              <select class="w-100 focus-outline-yellow" id="city" v-model="city" >
                <option value="" disabled>Select City</option>
                <option value="Mesa, AZ">Mesa, AZ</option>
                <option value="Chandler, AZ">Chandler, AZ</option>
                <option value="Tempe, AZ">Tempe, AZ</option>
                <option value="Scottsdale, AZ">Scottsdale, AZ</option>
                <option value="Apache Junction, AZ">Apache Junction, AZ</option>
                <option value="Gilbert, AZ">Gilbert, AZ</option>
                <option value="Phoenix, AZ">Phoenix, AZ</option>
              </select>
            </div> <!-- end .select -->
            <p class="help is-warning is-size-5" v-text="errors.get('city')" aria-live="polite" aria-atomic="true" aria-relevant="all" id="city__error-msg"></p>
          </div> <!-- end .control -->
        </div> <!-- end .field -->
        <div class="field">
          <p class="help is-warning is-size-5" v-text="errors.get('server')" aria-live="polite" aria-atomic="true" aria-relevant="all" id="server__error-msg"></p>
        </div>
        <div class="field">
          <div class="control text-left mt-4">
            <button
              @click.prevent="initSearch"
              :class="{ 'button is-info focus-outline-yellow': true, 'is-loading': loading }">
                Sort Schools
            </button>
          </div>
        </div>
      </fieldset>
    </form>

  </div> <!-- end sidebar -->
</template>

<script>
  import Radio from './Radio.vue'
  import CheckGroup from './CheckGroup.vue'
  import { $window } from '@/windowDimensions.js'
  import { Errors } from '@/helpers/errors.js'
  import throttle from 'lodash.throttle'

  export default {
    components: {
      cmpsCheckGroup: CheckGroup,
      cmpsRadio: Radio
    },
    data() {
      return {
        street: '',
        city: '',
        loading: false,
        errors: new Errors(),
        streetRegex: /^[0-9]{1,6}\s{1,2}(NW|NE|SW|SE|north|south|west|east|n|e|s|w)(\.|,)?\s{1,2}[\w\.\s]+[a-z\.]$/i
      }
    },
    computed: {
      categories() { return this.$store.state.search.categories },
      height() { return $window.width > 1215 ? 'auto' : $window.height - $window.sidebarYOffset + 'px' },
      offsetTop() { return $window.sidebarYOffset + 'px' },
      marginRight() {
        return $window.width > 1215
            ? '10px' // used to be 25px to match left margin, but browser scroll bar is 15px and throws off layout
            : this.$store.state.main.showMobileFilters
              ? '0px'
              : '-345px'
      }
    },
    mounted() {
      document.querySelector('#sidebar-container').focus()
    },
    methods: {
      initSearch: throttle(function() {
        this.loading = true
        this.errors.reset()

        // timeouts are for ux, so user knows the address filter is being triggered
        this.validateData()
        .then(() => {

          setTimeout(() => {
            this.$store.dispatch('addressSearch', `${this.street} ${this.city}`)
            // this.$store.dispatch('addressSearch', `$$$$$$$$$%`)
              .then(() => {
                document.documentElement.scrollIntoView()
                this.errors.reset()
                this.loading = false

                // Analytics Tracking
                gtag('event', 'address_applied', {
                  'event_category': 'sidebar_interaction',
                  'event_label': `${this.street} ${this.city}`
                })

              })
              .catch((error) => {
                this.loading = false
                this.errors.record({ server: [error] })
              })
          }, 1000)

        })
        .catch(() => {})

      }, 1500),
      validateData() {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            if (this.street === '') {
              this.loading = false
              this.errors.record({ street: ['Street address is required'] })
              document.querySelector('#street').focus()
              reject()
            } else if (this.city === '') {
              this.loading = false
              this.errors.record({ city: ['City is required'] })
              document.querySelector('#city').focus()
              reject()
            } else if (!this.streetRegex.test(this.street)) {
              this.loading = false
              this.errors.record({ street: ['Invalid street address'] })
              document.querySelector('#street').focus()
              reject()
            } else {
              resolve()
            }
          }, 500)
        })
      },
      reset() {
        this.$store.dispatch('reset')
        this.errors.reset()
        this.street = ''
        this.city = ''
        document.documentElement.scrollIntoView()

        // Analytics Tracking
        gtag('event', 'reset', {
          'event_category': 'sidebar_interaction'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  #sidebar-container {
    background-color: #126;
    color: #fff;
    width: 80%;
    max-width: 345px;
    position: fixed;
    right: 0;
    transition: margin-right 0.25s ease;
    overflow: auto;
    z-index: 30;
  }
  .sidebar-section {
    border: 0;
    border-bottom: 1px solid white;
    &:last-child {
      border: 0;
    }
    &.footer {
      background-color: inherit;
      padding: 0;
      text-align: center;
      margin-top: auto; // so section sticks to bottom of sidebar
    }
  }
  @media screen and (min-width: 1216px) {
    #sidebar-container {
      position: initial;
      width: 275px;
      box-shadow: 0px 6px 10px #999;
      margin: 1rem 25px;
    }
  }
  @media screen and (min-width: 1600px) {
    #sidebar-container {
      width: 345px;
      flex: 1 0 auto;
    }
  }
</style>
